<template>

<main class="py-12 space-y-12">
        <section>
            <div class="container grid lg:grid-cols-10 gap-12">
                <div class="lg:col-span-6">
                    <div class="dp-video js-fade-in is-added is-visible">
                        <VideoPlayer
                            url="/videos/Sauerland2025_Fundamente_720p.mp4"
                            name="Sauerland2025_Fundamente (1)"
                        />
                    </div>
                </div>
                <div class="lg:col-span-4">
                    <div class="article-text js-fade-in is-added is-visible">
                        <h2 class="h1 title">
                            Montage
                        </h2>
                        <p class="article-teaser">
                            Vor Auslieferung erhalten Sie von uns eine umfangreiche Liefermappe per Mail im PDF-Format.

                            Inhalt: Generelle Hinweise zur Montage und Wartung unserer Spielgeräte,
                            Hinweise und Vorschriften zur EN 1176, Wartungsprotokoll, Lieferschein,
                            Montage- und Fundamentpläne.

                            Unsere Spielgeräte sind weitestgehend vormontiert.
                        </p>
                        <p>
                            Um Ihnen die Montage noch weiter zu erleichtern, bieten wir Ihnen die Möglichkeit die
                            Fundamente per AR App auf der ausgekofferten Fläche zu projizieren.
                        </p>
                        <p>Erfahren Sie mehr dazu im Video!</p>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script setup lang="ts">
import VideoPlayer from '~/components/VideoPlayer.vue';

definePageMeta({
    path: '/Service/Montage',
});

const header = useState<{ title: string; subTitle: string }>(
    'header',
);
header.value = {
  title: 'Eine Welt',
  subTitle: 'voller Service',
};
</script>

<style scoped>

</style>
